import {finalize, mergeMap, filter, map, take} from 'rxjs/operators';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import {CoreActionCreatorService} from '@ispm/core/services/core-action-creator.service';
import {WorklistService} from '../../services/worklist.service';
import {Observable} from 'rxjs';
import {TestService} from '@ispm/test/services/test.service';
import {DynamicModalLoaderService} from '@ispm/layout/services/dynamic-modal-loader.service';
import {ConfirmModalComponent} from '@ispm/layout/components/modals/confirm-modal/confirm-modal.component';
import {ConfirmModalLoaderPayload} from '@ispm/layout/classes/confirm-modal-loader-payload';
import {ModalTypes} from '@ispm/layout/components/modals/contants/modal-types.enum';
import {TunnelResult} from '@ispm/layout/classes/tunnel-result';
import {modalResponse} from '@ispm/layout/constants/modal-responses.enum';
import * as lodash from 'lodash';
import {get, values} from 'lodash';
import {ITablelistAction, ResourceTypes} from '../../interfaces';
import {PermissionSchemaConstants} from '../../../shared/constants/permission-schema.constants';
import {ReviseService} from '@ispm/workflow/services/revise.service';
import {ReadOnlyParameters} from "@ispm/test/interfaces/read-only-parameters";
import {FormHandlerService} from '@ispm/shared/dynamic-form/services/form-handler.service';
import {Store} from '@ngrx/store';
import {IgenomicsState} from '../../../core/interfaces/genomics-state.interface';
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import {WorklistHelper} from '../../worklist-helper';
import {TranslateService} from "@ngx-translate/core";
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import { ReassignTestModalComponent } from '@ispm/layout/components/modals/reassign-test-modal/reassign-test-modal.component';
import { ReassignModalService } from '@ispm/layout/services/reassign-modal.service';
import { DiagnosticOrderService } from '@ispm/dashboard/test/services/diagnostic-order.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import {ActivatedRoute} from "@angular/router";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {EmrIntegrationService} from "@ispm/test/services/emr-integration.service";


@Component({
	selector: 'gen-worklist-actions',
	templateUrl: './worklist-actions.component.html',
	styleUrls: ['./worklist-actions.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorklistActionsComponent implements OnInit {
	lodash = lodash;
	public static readonly ACTIONS: Array<ITablelistAction> = [
		{
			key: 'reassign',
			label: 'Reassign Item',
			displayCondition: (self: WorklistActionsComponent) => {
				return self.reassignIsEnabled() && (
					self.type === WorklistHelper.TEST_WORKLIST_TYPE ||
					self.type.includes(WorklistHelper.PATIENT_DASHBOARD_TEST) ||
					self.type === WorklistHelper.ONCOSIGNAL_WORKLIST_TYPE ||
					self.displayActionItem(WorklistActionsComponent.ACTIONS[0].label));
			},
			enableCondition: (self: WorklistActionsComponent,action?:any) => {
				// 'Reassign test' action is disabled for admin user, regardless its current permissions
				return self.checkIfAdmin(self.authService.user) && (!self.disabledworklistActions?.includes(action?.label));
			},
			action: function (self) {
				self.reassign();
			}
		}, {
			key: 'remove',
			label: 'Remove from worklist',
			displayCondition: (self: WorklistActionsComponent) => {
				return self._isPerformer || self.displayActionItem(WorklistActionsComponent.ACTIONS[1].label);
			},
			enableCondition: (self: WorklistActionsComponent,action?:any) => {
				// disable action if current user does not have permissions to remove workflow from the list
				return self.permitRemoveWorkflowAnalysis && (!self.disabledworklistActions?.includes(action?.label));
			},
			action: function (self) {
				self.removeFromWorklist();
			}
		}, {
			key: 'archive',
			label: 'Archive item',
			displayCondition: (self: WorklistActionsComponent) => {
				return (self.type === WorklistHelper.TEST_WORKLIST_TYPE ||
					self.type.includes(WorklistHelper.PATIENT_DASHBOARD_TEST) ||
					self.type === WorklistHelper.ONCOSIGNAL_WORKLIST_TYPE ||
					self.displayActionItem(WorklistActionsComponent.ACTIONS[2].label)) && self.readOnlyModeIsSupported();
			},
			enableCondition: (self: WorklistActionsComponent,action?:any) => {
				// disable action if current user does not have write permissions to workflow
				return self.permitWorkflowWrite && (!self.disabledworklistActions?.includes(action?.label));
			},
			action: function (self) {
				self.archiveTest();
			}
		}];
	public static readonly DISABLED_ACTIONS: Array<ITablelistAction> = [
		{
			key: WorklistHelper.REVISE_ACTION_KEY,
			label: 'Advance/Revise item',
			action: (self: WorklistActionsComponent) => {
				self.revise(self.rowData);
			},
			displayCondition: (self: WorklistActionsComponent) => {
				return self.type === WorklistHelper.TEST_WORKLIST_TYPE || self.type.includes(WorklistHelper.PATIENT_DASHBOARD_TEST);
			},
			enableCondition: (self: WorklistActionsComponent) => {
				return self.permitWorkflowRevise;
			}
		}
	];

	public static readonly CURATION_ACTIONS: Array<ITablelistAction> = [];


	public static ACTIVE_ACTIONS: Array<ITablelistAction> = WorklistActionsComponent.ACTIONS;
	@Input() rowData;
	@Input() currentUserId;
	@Input() trackByField: string;
	@Input() practitionerType: string;
	@Input() type: string;
	@Input() injectedActions: Array<ITablelistAction>;
	@Input() worklistActions: any;
    @Input() disabledworklistActions: any;
	@Input() mode: any;
	public activeRow: Observable<string>;
	public actions;
	private permitRemoveWorkflowAnalysis: boolean;
	private permitWorkflowWrite: boolean;
	private permitWorkflowRevise: boolean;
	private _isPerformer: boolean = false;
	private readOnlyParameters: ReadOnlyParameters;

    constructor(private workflowService: WorkflowService,
				private notificationMessageService: NotificationMessageService,
        private notificationMessage: NOTIFICATION_MESSAGE,
        private authService: AuthenticationService,
        private diagnosticOrderService : DiagnosticOrderService,
        private testService: TestService,
        private _changeDetector: ChangeDetectorRef,
        private modalLoaderService: DynamicModalLoaderService,
        private activatedRoute: ActivatedRoute,
        private coreAC: CoreActionCreatorService,
        private worklistService: WorklistService,
        private _reviseService: ReviseService,
        private formHandlerService: FormHandlerService,
        private store: Store<IgenomicsState>,
        private _translate: TranslateService,
        private userActionCreatorService: UserActionCreatorService,
        public reassignModalService: ReassignModalService,
        private routerManagerService: RouterManagerService,
                private emrIntegrationService: EmrIntegrationService) {
      this.activeRow = this.worklistService.getActiveRowObservable();
    }

	ngOnInit() {
    this.setReadOnlyModeParameters();
    // get if current user has the following permissions:
    this.practitionerType = this.practitionerType ? this.practitionerType : 'performer';
    this.permitRemoveWorkflowAnalysis = this.authService.doesUserHasPermission(PermissionSchemaConstants.schemaWorkflowAnalysisRemove); // remove workflow from the list
    this.permitWorkflowWrite = this.authService.doesUserHasPermission(PermissionSchemaConstants.schemaWorkflowWrite); // change workflow (archive test)
    this.permitWorkflowRevise = this.authService.doesUserHasPermission(PermissionSchemaConstants.shcemaWorkflowAnalysisRevise);
    this._isPerformer = this.isPerformer(this.currentUserId);

    /**
     * get the active actions after reduce
     *
     * @link PatientDashboardComponent setWorklistActions()
     * @type {{key: string; label: string; action: (()=>any)}[]}
     */
	   this.actions = WorklistActionsComponent.ACTIVE_ACTIONS.filter(action => this.shouldDisplayAction(action));
	}

    setReadOnlyModeParameters() {
        if (this.rowData && this.rowData.readOnlyParameters) {
          const readOnlyDesc = this.rowData.readOnlyParameters;
          this.readOnlyParameters = this.reassignModalService.setReadOnlyModeParameters(readOnlyDesc, this.rowData,this.authService.user);
        }
    }


	shouldDisplayAction(action: ITablelistAction): boolean {
    return action.displayCondition(this, action);
  }

	public shouldEnableAction(action: ITablelistAction): boolean {
		return action.enableCondition(this, action);
	}

	getTextFromHtml(value) {
		return this.worklistService.getTextFromHtml(value);
	}

	public closeActions() {
		this.worklistService.updateActiveRow(null);
	}

	public actionClicked($event) {
		$event.stopPropagation();
		//Revise\Advanced action 'displayCondition' was called when action was created. It checked worklist type and made the action visible fo the relvant workists.
		//Here, when 3 dots were cliecked, testing conditions that require the row data (which we may not fully have when action was created) and decide if the action should be shown.
		if (this.actions){
			const reviseActionId = this.actions.findIndex(item=>item.key === WorklistHelper.REVISE_ACTION_KEY);
			if (reviseActionId !== -1){
				if (!this.rowData.revCheckpoints || !this.rowData.allowRevise || !this._isPerformer){
					this.actions.splice(reviseActionId, 1);
				}
			}
		}
		this.activeRow.pipe(take(1))
			.subscribe(id => {
				this.worklistService.updateActiveRow(id === lodash.get(this.rowData, this.trackByField)
					? null
					: lodash.get(this.rowData, this.trackByField));
				this._changeDetector.detectChanges();
			});
	}

	public applyAction(action: (self, action?: ITablelistAction) => void, actionData: ITablelistAction) {
		action(this, actionData);
	}

	private displayActionItem(actionlabel: string): boolean{
		if (this.worklistActions) {
			return (values(this.worklistActions).includes(actionlabel) && this.mode === ResourceTypes.Generic);
		} else {
			return false;
		}
	}

  private checkIfAdmin(user): boolean {
      return user.isAdmin ? (user.permissions.includes('ADMIN.ORGANIZATION.WORKLIST')
        && user.permissions.includes('ADMIN.ORGANIZATION.WORKLIST.CREATE')) ? true : false : true;
  }
	/**
	 * removing test from user worklist - relays on NGJS service
	 * old design
	 */
	private removeFromWorklist() {
		let modalPayload: any = {};
		modalPayload.modalName = 'ReamoveModal';
		modalPayload.title = 'Remove test from worklist';

		this.modalLoaderService.popupModal(ReassignTestModalComponent,
		{
			content: modalPayload,
			backdropAllowed: false
		}, ModalTypes.NONE).subscribe((data) => {
			if (data && data.payload && data.payload.action === 'ok') {
				this.coreAC.setLoader(true);
				this.workflowService.getWorklfowById(this.rowData.workflowrequest_id ? this.rowData.workflowrequest_id : lodash.get(this.rowData, this.trackByField))
					.then((workflowResult) => {
						return this.workflowService.removeAnalysisFromWorklist(workflowResult.body,
							(this.rowData.activeRevision ? this.rowData.activeRevision : this.rowData.WorkflowRequest['revisions_-1_id']),
							this.authService.user.info.id).subscribe((ans) => {
							setTimeout(() => {
								this.notificationMessageService.success(this.notificationMessage.TEST_REMOVED_FROM_YOUR_WORKLIST_SUCCESSFULLY);
							},0);
              this.worklistService.actionUsed = true;
              				this.routerManagerService.reloadSamePage();
						});
					})
					.catch(err => {
						this.notificationMessageService.error(this.notificationMessage.ERROR_WHILE_REMOVING_TEST_FROM_WORKLIST);
					})
					.finally(() => {
						this.coreAC.setLoader(false);
					});
			}
		});
	}

	/**
	 * removing test from ALL worklist - NG2 with new modal design
	 */
	private archiveTest() {
		this.modalLoaderService.popupModal(
			ConfirmModalComponent,

			new ConfirmModalLoaderPayload(`Archive  ${this.rowData.test_number? this.rowData.test_number[0].value: ""}`,
				'This will remove the test from all worklists.' +
				' Archived tests can be accessed through the system search and/or patient test panel. Do you wish to archive this test?',
				'Archive',
				'Cancel'),
			ModalTypes.ALERT
		).pipe(
			map((res: TunnelResult) => res.getData()),
			filter(response => response === modalResponse.approve),
			mergeMap(() => this.testService.archiveTest(this.rowData.workflowrequest_id ? this.rowData.workflowrequest_id : lodash.get(this.rowData, this.trackByField))),
			finalize(() => {
				this.coreAC.setLoader(false);
			}))
			.subscribe(data => {
        this.worklistService.actionUsed = true;
        		this.routerManagerService.reloadSamePage();
			});
	}

	/**
	 * reassign test  - relays on NGJS service
	 * old design
	 */
	private reassign() {
		const practitionerFilterBy = get(this.readOnlyParameters, 'practitionerFilterBy', undefined);

		if (this.rowData && this.rowData.references) {
			this.rowData.practitionerFilterBy = practitionerFilterBy;
			this.workflowService.currentTest = this.rowData;
			this.workflowService.currentTest.workflowRequest = { references: this.rowData.references};

		} else {
			this.workflowService.currentTest = {
				activeRevision: this.rowData.WorkflowRequest['revisions_-1_id'],
				workflowrequest_id: this.rowData.WorkflowRequest.id,
				practitionerFilterBy: practitionerFilterBy,
				workflowRequest: this.rowData.WorkflowRequest
			};
		}

		let allowedRolesForReassignment: any;
		this.userActionCreatorService.getStoredOrganizationConfiguration()
		.take(1)
		.map((organization) => {
			allowedRolesForReassignment = organization.allowedRolesForReassignment ? organization.allowedRolesForReassignment : ['Pathologist', 'Pathologist Role for Genomics App', 'Oncologist Role for Genomics app'];
		}).toPromise();

		let modalPayload: any = {};
		modalPayload.name = this.getTextFromHtml(this.rowData.pat_name ? this.rowData.pat_name : lodash.get(this.rowData,'Patient.name_0_text'));
		modalPayload.testNumber = this.getTextFromHtml(this.rowData.test_number? this.rowData.test_number[0].value: "");
		modalPayload.analysis = this.workflowService.currentTest;
		modalPayload.practitionerRoles = allowedRolesForReassignment;
		modalPayload.enableReassign = allowedRolesForReassignment !== null ? (this.reassignModalService.isAdminHasPermissionToReassign(this.authService.getUser()) ? true :
      !!(allowedRolesForReassignment.find(role => role.toLocaleLowerCase() === this.authService.getUser().role.toLocaleLowerCase()))) : true;
		modalPayload.practitionerFilterBy = modalPayload.analysis.practitionerFilterBy;
		modalPayload.disallowedPractitionerRoles = ['Provider'];
		modalPayload.modalName = 'ReassignTest';
		modalPayload.title = modalPayload.name + ', Item No. ' + modalPayload.testNumber;

		this.modalLoaderService.popupModal(ReassignTestModalComponent,
		{
			content: modalPayload,
			backdropAllowed: false
		}, ModalTypes.NONE).subscribe((data) => {
			if (data && data.payload && data.payload.action === 'close') {
        this.worklistService.actionUsed = true;
        		this.routerManagerService.reloadSamePage();
			}
		});
	}

	private revise(rowData: any) {

	  const patientId = rowData.patient_id;
      const workflowId = rowData.workflowrequest_id;

      if (rowData.revCheckpoints) {
          const checkpoint = rowData.revCheckpoints[0];
          this._reviseService.openReviseModal({
              component: ConfirmModalComponent,
              payload: new ConfirmModalLoaderPayload('', `Please confirm that the diagnosis has not changed and you are revising the treatment or advancing to the next step in treatment`, 'Confirm', 'Cancel'),
              revisionCheckpoint: checkpoint,
              revisionId: rowData.lastRevision, // **Note: lastRevision is the revision that was clicked in the worklist, not the latest one in the workflow
              workflowId: workflowId
          }).subscribe((res: any) => {
              if (res) {
                const emrIntegration = this.emrIntegrationService.getEMRIntegration();
                this.worklistService.redirectToPatientProfileTest(patientId, workflowId, res.activeRevision, emrIntegration, this.routerManagerService.reloadSamePage());
              }
          });
      }
	}

	private isPerformer(userId: string): boolean {
	  var self = this;
		return this.rowData.references && this.rowData.references.find((ref) => {
			if (ref.key === 'practitioner') {
				const refVal = JSON.parse(ref.value);
				return (refVal.practType === self.practitionerType && refVal.practId === userId);
			}
			return false;
		});
	}

  public trackByKey(index, item: ITablelistAction) {
    return item.key;
  }

  reassignIsEnabled(): boolean {
    if (this.readOnlyParameters) {
      return this.reassignModalService.reassignIsEnabled(this.readOnlyParameters);
    }
    return true;
  }

  protected readOnlyModeIsSupported(): boolean {
    if (this.readOnlyParameters) {
      return this._isPerformer;
    }
    return true;
  }
}
